function replaceTokens(queryStringTemplate, searchParams) {
    try {
        // when the queryParam is empty we copy non-empty value from the current url
        var templateSearchParams = new URLSearchParams(queryStringTemplate || searchParams);
        var currentPageSearchParams_1 = new URLSearchParams(searchParams);
        var resultSearchParams_1 = new URLSearchParams();
        templateSearchParams.forEach(function (value, key) {
            var _a;
            var tokenRegexp = /\{(\w*)\}/;
            // Ref:https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match#using_match
            var token = (_a = value.match(tokenRegexp)) === null || _a === void 0 ? void 0 : _a[1];
            // when not a tokenized value in template, copy existing value
            if (token === undefined) {
                if (value)
                    resultSearchParams_1.append(key, value);
                return;
            }
            // when token is valid, look up value from current search params and copy
            var valueInCurrentUrl = currentPageSearchParams_1.get(token);
            if (valueInCurrentUrl) {
                resultSearchParams_1.append(key, valueInCurrentUrl);
            }
        });
        return resultSearchParams_1.toString();
    }
    catch (error) {
        return '';
    }
}
export var KEEP_EMPTY_FLAG = 'KEEP_EMPTY_FLAG';
// handles the current impementation, breaking the Sitecore field into an array
var getQueryStringParamsFromCanonicalParamsFieldValue = function (_a) {
    var _b, _c, _d;
    var canonicalProps = _a.canonicalProps, searchParams = _a.searchParams, isAlternate = _a.isAlternate;
    var canonicalParams = (_c = (_b = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.canonicalParams) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.split('\r\n');
    if (!Array.isArray(canonicalParams) || !canonicalParams.length)
        return '';
    if (canonicalParams[0] === KEEP_EMPTY_FLAG) {
        return '';
    }
    var firstEntry = canonicalParams[0] || '';
    var secondEntry = (_d = canonicalParams[1]) !== null && _d !== void 0 ? _d : firstEntry;
    var queryStringParams = isAlternate ? secondEntry : firstEntry;
    var finalQuery = replaceTokens(queryStringParams, searchParams);
    var queryString = finalQuery || searchParams || '';
    if (queryString.length && queryString[0] !== '?') {
        queryString = "?".concat(queryString);
    }
    return queryString;
};
// simplified version of the current implementation...
export var getCanonicalPath = function (currentLanguage, languageSelectors, canonicalProps, searchParams, pathName) {
    var _a;
    var currentLanguageSelector = languageSelectors.find(function (selector) { return selector.code === currentLanguage; });
    var queryString = getQueryStringParamsFromCanonicalParamsFieldValue({
        canonicalProps: canonicalProps,
        searchParams: searchParams,
        isAlternate: false,
    });
    // En
    var canonicalUrl = (_a = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.canonicalUrl) === null || _a === void 0 ? void 0 : _a.value;
    var renderUrl = canonicalUrl || ((pathName === null || pathName === void 0 ? void 0 : pathName.endsWith('/')) ? pathName : currentLanguageSelector === null || currentLanguageSelector === void 0 ? void 0 : currentLanguageSelector.url);
    return "".concat(renderUrl).concat(queryString);
};
export var getAlternatePath = function (currentLanguage, languageSelectors, canonicalProps, searchParams, pathName) {
    var _a;
    var alternateLanguageSelector = languageSelectors.find(function (selector) { return selector.code !== currentLanguage; });
    var queryString = getQueryStringParamsFromCanonicalParamsFieldValue({
        canonicalProps: canonicalProps,
        searchParams: searchParams,
        isAlternate: true,
    });
    // FR
    var alternateHref = (_a = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.alternateHref) === null || _a === void 0 ? void 0 : _a.value;
    var renderUrl = alternateHref || ((pathName === null || pathName === void 0 ? void 0 : pathName.endsWith('/')) ? pathName : alternateLanguageSelector === null || alternateLanguageSelector === void 0 ? void 0 : alternateLanguageSelector.url);
    return "".concat(renderUrl).concat(queryString);
};
export var getAlternateLanguageCode = function (currentLanguage, languageSelectors) { var _a; return (_a = languageSelectors.find(function (selector) { return selector.code !== currentLanguage; })) === null || _a === void 0 ? void 0 : _a.code; };
